import {  useState } from "react"
import { AccountAccess } from "../components/account-access.component"
import { Footer } from "../components/footer.component"
import Header from "../components/header.component"
import { HeroSection } from "../components/hero-section.component"
import { PartnerLogo } from "../components/partner-logo.component"
import TestimonialsSection from "../components/testimonials-section.component"
import TrustpilotBadge from "../components/trustpilot-badge.component"
import '../scss/main.scss'
import { ChooseInvozio } from "../components/choose-invozio"
import { InvoicingForBusiness } from "../components/invoicing-for-business.component"
import { Benefits } from "../components/benefits.component"
import { EmployeesWork } from "../components/employees-work.component"
import { useSelector } from "react-redux"

export const Business = () => {
  interface RootState {
    auth: {
      user: string | null;
    };
  }
  const user = useSelector((state: RootState) => state.auth.user);


  const sectionConfig = {
    ChooseInvozio,
    TrustpilotBadge,
    InvoicingForBusiness,
    Benefits,
    EmployeesWork,
    TestimonialsSection,
  };

  return (
    <>
      <Header  />
      <HeroSection  />
      <PartnerLogo />
      {Object.entries(sectionConfig).map(([key, Component]) => (
        <Component key={key} />
      ))}
      <div className="bg-footer">
        <AccountAccess />
        <Footer />
      </div>
    </>
  );
}
